import type { ToolDefinition } from './types';

// Short forms stay centered; editors, tables and visual canvases keep a roomy workspace.
const compactTools = new Set([
  'timer', 'eta-calculator', 'roman-converter', 'nato-spelling', 'browser-benchmark', 'emoji-picker',
  'timestamp', 'amount-uppercase', 'unit-converter', 'radix-converter', 'color-converter',
  'percentage-calculator', 'loan-calculator', 'health-calculator', 'calendar-event', 'css-unit',
  'naming-converter', 'robots-generator', 'semver-compare',
  'mime-lookup', 'idn-safety', 'expense-split', 'snowflake-inspector',
  'print-size', 'reading-plan', 'playback-time', 'pace-calculator', 'date-sequence',
  'fraction-arithmetic', 'quadratic-solver', 'triangle-solver', 'screen-density'
]);
const wideTools = new Set([
  'table-split', 'stratified-sample', 'gantt-chart', 'flashcards', 'answer-sheet', 'matrix-workbench',
  'bibliography-converter', 'git-patch', 'websocket-frame', 'http-chunked', 'saml-inspector',
  'bencode-inspector', 'sse-inspector', 'ansi-log', 'image-channels',
  'whiteboard', 'quick-page', 'json-schema', 'pdf-preflight', 'pdf-poster', 'docx-revisions', 'audio-spectrum',
  'modbus-frame', 'mqtt-packet', 'dns-packet', 'protobuf-wire', 'cbor-inspector', 'msgpack-inspector',
  'asn1-inspector', 'pcap-inspector', 'binary-struct', 'riff-inspector', 'jwe-workbench', 'hkdf-workbench',
  'arithmetic-sheet', 'tracing-sheet', 'list-compare', 'text-chunker', 'text-template', 'fixed-width',
  'markdown-table', 'json-flatten', 'table-pivot', 'table-transpose', 'table-wide-long',
  'moving-average', 'data-bins', 'linear-fit', 'data-normalize', 'path-tree', 'http-headers',
  'sql-in-list', 'sql-insert', 'base32-codec', 'url-editor', 'glob-tester', 'office-viewer',
  'pdf-text', 'pdf-toc', 'pdf-to-image', 'pdf-compress', 'document-metadata', 'ofd-inspector',
  'email-viewer', 'xmind-viewer', 'archive', 'password-hash', 'frontend-security', 'passkey-inspector', 'oauth-inspector',
  'material-check', 'folder-compare', 'print-paper', 'file-hash', 'subtitle-converter',
  'input-device-test', 'text-cleaner', 'encryption', 'mock-data', 'qr-code', 'barcode', 'industry-barcode', 'ocr',
  'pdf-pages', 'pdf-create', 'pdf-privacy', 'pdf-signature', 'pdf-form-filler', 'pdf-resource-extractor',
  'pdf-compare-overlay', 'pdf-nup-booklet', 'table-cleaner', 'batch-docs', 'data-chart', 'docx-template',
  'log-analyzer', 'sql-workbench', 'data-codec', 'data-format-converter', 'openapi-workbench', 'json-diff',
  'json-query', 'mermaid-editor', 'markdown-preview', 'code-formatter', 'api-request', 'mqtt-client',
  'websocket-client', 'image-annotate', 'image-stitch', 'image-diff', 'csv-explorer', 'week-planner',
  'social-image-studio', 'social-image-crop', 'svg-workbench', 'font-workbench', 'audio-workbench',
  'audio-waveform', 'media-studio', 'video-to-gif', 'document-version-diff', 'html-markdown'
]);

export function toolPresentation(definition: Pick<ToolDefinition, 'id' | 'parentToolId'>): 'compact' | 'standard' | 'wide' {
  const id = definition.parentToolId || definition.id;
  return compactTools.has(id) ? 'compact' : wideTools.has(id) ? 'wide' : 'standard';
}
